module.exports = __webpack_public_path__ + "img/hook_MARTEC_OKE_4.624767dc.png";